module.exports = __webpack_public_path__ + "img/step3_a_locate components - Copy.d2b66e6c.png";